export const DISCLOSURE_REPORT_PAGE_SIZE = 10
